let dataServe = "https://cr.apmem.com";
// let dataServe = "http://localhost:8266";

let dataPool = {
  //获取期次信息列表
  getExamPeriodInfoList: dataServe + "/App/GetExamPeriodInfoList",
  //获取获取试卷信息
  getQuestionList: dataServe + "/App/GetQuestionList",
  //获取模拟试卷信息的答案及解析
  getExamineTestAnswer: dataServe + "/App/GetExamineTestAnswer",
  //提交答案信息
  submitPCExamineUserAnswer: dataServe + "/App/SubmitPCExamineUserAnswer",
  //提交试卷信息，返回考核成绩及考核结果
  submitPCExamine: dataServe + "/App/SubmitPCExamine",
  //获取身份证号关联的期次信息列表
  getIDCardRelevanceExamPeriodInfoList: dataServe + "/App/GetIDCardRelevanceExamPeriodInfoList",
  getIdCardRsaKey: dataServe + "/App/GetIdCardRsaKey",
};

export default dataPool;


// WEBPACK FOOTER //
// ./src/api/data.js